import Vue from "vue";
import {api as configs} from "@/app/config";
import {getData} from "@/app/plugins/utils";

export const getUsers = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'user'+payload).then(getData)
}
export const postUsers = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'user', payload).then(getData)
}
// export const postDisableClients = (payload = '') => {
//   return Vue.http.post(configs.baseUrl+'department_store/disableClient/'+payload, '').then(getData)
// }
export const putUsers = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'user/'+payload.id, payload).then(getData)
}
export const delUsers = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'user/'+payload, '').then(getData)
}

export const getGerenteMarketplaces = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace_manager'+payload).then(getData)
}
export const postGerenteMarketplaces = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'marketplace_manager', payload).then(getData)
}
export const putGerenteMarketplaces = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'marketplace_manager/'+payload.id, payload).then(getData)
}
export const deleteGerenteMarketplaces = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'marketplace_manager/'+payload, '').then(getData)
}

export const getPlan = (payload = '') => {
  return Vue.http.get(configs.baseUrl + 'plan' + payload).then(getData)
}

export const postPlan = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'plan', payload).then(getData)
}
export const postCardSeAccredidation = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'card_se/accredidation', payload).then(getData)
}
export const putCardSeAccredidation = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'card_se/accredidation/'+payload.id, payload).then(getData)
}
export const putPlan = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'plan/'+payload.id, payload).then(getData)
}
export const postPlanFee = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'plan_fee', payload).then(getData)
}

export const postMigrarPlanoEC = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'department_store_plan/migration', payload).then(getData)
}

export const getPlanosMarketplaces = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace_plan'+payload).then(getData)
}
export const postPlanosMarketplaces = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'marketplace_plan', payload).then(getData)
}
export const postDesassociarPlanosMarketplaces = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'marketplace_plan/'+payload.id, payload.data).then(getData)
}

export const postGenerateQRCodeGoogle = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'user/'+payload.idUser+'/generate_qrcode_google', payload.data).then(obj => {return obj})
}

export const getMarketplaces = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace'+payload).then(getData)
}
export const postMarketplaces = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'marketplace', payload).then(getData)
}
export const postChangeTypeMarketplaces = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'marketplace/alter_type', payload).then(getData)
}
export const putMarketplaces = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'marketplace/'+payload.id, payload).then(getData)
}
export const deleteMarketplaces = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'marketplace/'+payload, '').then(getData)
}
export const deletePlanos = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'plan/'+payload, '').then(getData)
}

export const getSyncProviderEstaComercial = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store_sync'+payload).then(getData)
}

export const postSyncProviderEstaComercial = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'department_store_sync', payload).then(getData)
}
export const getPlanosEstaComercial = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store_plan'+payload).then(getData)
}
export const postDesassociarPlanosEstaComercial = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'department_store_plan/'+payload.id+'/disassociate', payload.data).then(getData)
}
export const postPlanosPlanosEstaComercial = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'department_store_plan', payload).then(getData)
}
export const getEstaComercial = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store'+payload).then(getData)
}
export const showEstaComercial = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store/'+payload).then(getData)
}
export const exportECs = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/department_store'+payload).then(getData)
}
export const postEstaComercial = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'department_store', payload).then(getData)
}
export const postSendECProvider = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_provider', payload).then(getData)
}
export const putEstaComercial = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'department_store/'+payload.id, payload).then(getData)
}
export const deleteEstaComercial = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'department_store/'+payload, '').then(getData)
}
export const postSendApprovePerson = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_checklist', payload).then(getData)
}

export const getModelEquipamento = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'equipment_model'+payload).then(getData)
}
export const postModelEquipamento = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'equipment_model', payload).then(getData)
}
export const putModelEquipamento = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'equipment_model/'+payload.id, payload).then(getData)
}
export const deleteModelEquipamento = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'equipment_model/'+payload, '').then(getData)
}

export const getEquipamentos = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'equipment'+payload).then(getData)
}
export const postEquipamentos = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'equipment', payload).then(getData)
}
export const deleteEquipamentos = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'equipment/'+payload, '').then(getData)
}
export const putEquipamentos = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'equipment/'+payload.id, payload).then(getData)
}

export const getTerminais = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'terminal'+payload).then(getData)
}
export const getExportTerminais = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/terminal'+payload).then(getData)
}
export const postTerminais = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'terminal', payload).then(getData)
}
export const postSyncProviderTerminais = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'terminal_sync', payload).then(getData)
}
export const postDesassociarTerminais = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'terminal/disassociate', payload).then(getData)
}
export const putTerminais = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'terminal/'+payload.id, payload).then(getData)
}
export const deleteTerminais = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'terminal/'+payload, '').then(getData)
}

export const getRepresentantes = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'agent'+payload).then(getData)
}
export const getPlanoRepresentante = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'agent_plan'+payload).then(getData)
}

export const postDesassociarPlanosRepresentante = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'agent_plan/'+payload.id, payload.data).then(getData)
}
export const postDesassociarMktRepresentante = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'agent/'+payload+'/disassociate', ).then(getData)
}
export const postAssociarMktRepresentante = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'agent/'+payload.id+'/associate', payload.data).then(getData)
}
export const postAssociarPlanosRepresentante = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'agent_plan', payload).then(getData)
}
export const putRepresentantes = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'agent/'+payload.id, payload).then(getData)
}
export const postRepresentantes = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'agent', payload).then(getData)
}
export const postChangeTypeRepresentantes = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'agent/alter_type', payload).then(getData)
}
export const deleteRepresentantes = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'agent/'+payload, '').then(getData)
}

export const getDocumentsPerson = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'person_document'+payload).then(getData)
}
export const postDocumentsPerson = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_document', payload).then(getData)
}

export const getBankDados = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'bank_account'+payload).then(getData)
}
export const postBankDados = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'bank_account', payload).then(getData)
}

export const getTaxaPortador = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store/holder_fee/'+payload).then(getData)
}
export const putTaxaPortador = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'department_store/holder_fee/'+payload.idEC, payload.data).then(getData)
}

export const getAprovarContas = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'person_checklist'+payload).then(getData)
}
export const postAprovarContas = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_checklist/'+payload+'/approve', '').then(getData)
}
export const postRefuseCR = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_checklist/'+payload+'/refuse', '').then(getData)
}
export const getListDepositosV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/schedule'+payload).then(getData)
}
export const getExportDepositosV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/export/schedule'+payload).then(getData)
}

export const getListDepositosConsilided = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'schedule/consilided'+payload).then(getData)
}
export const getAdjustsDetails = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'schedule/adjusts_details',payload).then(getData)
}
export const getReceivablesDetails = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'schedule/receivables_details',payload).then(getData)
}

export const getContractEffectDetails = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'schedule/contract_effect_details',payload).then(getData)
}

export const getPersonAcquirer = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'person_acquirer'+payload).then(getData)
}

export const getPersonAcquirerTerminalCodes = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'person_acquirer_terminal_codes'+payload).then(getData)
}

export const sendPersonAcquirer = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_acquirer/send', payload).then(getData)
}

export const sendPersonAcquirerRede = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_acquirer/send_rede', payload).then(getData)
}

export const getPriorityAcquirer = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'person_acquirer/priority_acquirer'+payload).then(getData)
}

export const savePriorityAcquirer = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'person_acquirer/save_priority_acquirer', payload).then(getData)
}

export const getListaAnaliseRisco = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis'+payload).then(getData)
}

export const getListaAnaliseRiscoBeneficiarios = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/beneficiary'+payload).then(getData)
}

export const getAnaliseRisco = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis'+payload).then(getData)
}

export const getAnaliseRiscoBeneficiario = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/beneficiary'+payload).then(getData)
}

export const putAprovarAnalise = (id, payload) => {
  return Vue.http.put(configs.baseUrl+'risk_analysis/'+id, payload).then(getData)
}

export const putAprovarAnaliseBeneficiario = (id, payload) => {
  return Vue.http.put(configs.baseUrl+'risk_analysis/beneficiary/'+id, payload).then(getData)
}

export const putAtualizarStatus = (id, payload) => {
  return Vue.http.put(configs.baseUrl+'risk_analysis/'+id+'/status', payload).then(getData)
}

export const putReprovarAnalise = (id, payload) => {
  return Vue.http.put(configs.baseUrl+'risk_analysis/'+id, payload).then(getData)
}

export const putReprovarAnaliseBeneficiario = (id, payload) => {
  return Vue.http.put(configs.baseUrl+'risk_analysis/beneficiary/'+id, payload).then(getData)
}

export const getRetryAnalise = (id) => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/'+id+'/retry').then(getData)
}

export const getListDigitalAnalysis = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/digitalAnalysis'+payload).then(getData)
}
export const postAnalysisDigitalPayment = (id, payload = '') => {
  return Vue.http.post(configs.baseUrl+`department_store/${id}/analysisPaymentDigital`, payload).then(getData)
}
export const putDigitalAnalysis = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+`risk_analysis/digitalAnalysis/${id}`, payload).then(getData)
}
export const getRetryDigitalAnalise = (id) => {
  return Vue.http.get(configs.baseUrl+`risk_analysis/digitalAnalysis/${id}/retry`).then(getData)
}
export const putUpdateStatusDigitalAnalysis = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+`risk_analysis/digitalAnalysis/${id}/status`, payload).then(getData)
}

export const putConfigSettlement = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+`department_store/${id}/settlement_management`, payload).then(getData)
}

export const getConfigSettlement = (id, payload = '') => {
  return Vue.http.get(configs.baseUrl+`department_store/${id}/settlement_management`, payload).then(getData)
}

export const postRequestConfigSettlement = (id, payload = '') => {
  return Vue.http.post(configs.baseUrl+`department_store/${id}/settlement_management/request`, payload).then(getData)
}

export const getSettlementRequest = (id, payload = '') => {
  return Vue.http.get(configs.baseUrl+`department_store/${id}/settlement_management/request`, payload).then(getData)
}

export const putRequestSettlement = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+`department_store/${id}/settlement_management/request`, payload).then(getData)
}

export const getSearchDocument = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store/searchDocument'+payload).then(getData)
}

export const getSettlementHistory = (id, payload = '') => {
  return Vue.http.get(configs.baseUrl+`department_store/${id}/settlement_management/history`, payload).then(getData)
}

export const updateNameEstaComercial = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+`department_store/${id}/updateName`, payload).then(getData)
}

export const postImportFees = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'plan_fees/import', payload).then(getData)
}
export const postImportLogoMarketplace = (id, payload = '') => {
  return Vue.http.post(configs.baseUrl+`import/logo/marketplace/${id}`, payload).then(getData)
}
export const postImportBannerMarketplace = (id, payload = '') => {
  return Vue.http.post(configs.baseUrl+`import/banner/marketplace/${id}`, payload).then(getData)
}
export const postImportEquipment = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'import/equipment', payload).then(getData)
}